import { useAuthStore } from "@/state/pinia";

export default [
  // --- ACCUEIL ---
{
  path: "/",
  name: "homePage",
  meta: { authRequired: false },
  beforeEnter: (to, from, next) => {
    const loggeduser = localStorage.getItem("user");

    if (!loggeduser) return next();

    try {
      const user = JSON.parse(loggeduser);
      const role = user?.role?.name;
      const typePartenaire = user?.partenaire?.type?.toUpperCase();

      // Mapping des rôles simples
      const roleRedirects = {
        'ADMIN': 'analytic',
        'INDIVIDUEL': 'chat',
        'EMPLOYER': 'employers',
        'AYANT_DROIT':  'ayantDroit'
      };

      if (roleRedirects[role]) {
        return next({ name: roleRedirects[role] });
      }

      // Logique spécifique pour les partenaires
      if (role === 'RESPONSABLE_PARTENAIRE') {
        const partenaireRedirects = {
          'HOPITAL': 'hopital-dashboard',
          'PHARMACIE': 'pharmacie-dashboard'
        };

        // Redirige vers le dashboard spécifique ou Wallet par défaut
        const targetName = partenaireRedirects[typePartenaire] || 'Wallet';
        return next({ name: targetName });
      }

      next();
    } catch (e) {
      console.error("Erreur de parsing utilisateur", e);
      localStorage.removeItem("user"); // Nettoyage si données invalides
      next();
    }
  },
  component: () => import("../views/home/homePage")
},
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login"),
    meta: { 
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        const auth = useAuthStore();
        auth.loggedIn ? next({ name: "homePage" }) : next();
      }
    }
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register"),
    meta: { title: "Register" }
  },
  {
  path: "/forgot-password",
  name: "forgot-password",
  component: () => import("../views/account/forgot-password"), // Assurez-vous que le fichier existe
  meta: {
    title: "Mot de passe oublié",
    beforeResolve(routeTo, routeFrom, next) {
      const auth = useAuthStore();
      // Si déjà connecté, on redirige vers la home, sinon on laisse passer
      auth.loggedIn ? next({ name: "homePage" }) : next();
    }
  }
},

  // --- DASHBOARD (ADMIN UNIQUEMENT) ---
   {
    path: "/dashboard/blog",
    name: "blog-dashboard",
    meta: { title: "Blog-Dashboard", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/blog/index")
  },
  
  {
    path: "/dashboard/paiements",
    name: "paiements-dashboard",
    meta: { title: "Paiements", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/paiements/index")
  },
  {
    path: "/dashboard/souscriptions",
    name: "souscriptions-dashboard",
    meta: { title: "Souscriptions", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/souscriptions/index")
  },
  {
    path: "/dashboard/utilisateurs",
    name: "utilisateurs-dashboard",
    meta: { title: "Utilisateurs", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/utilisateurs/index")
  },
  {
    path: "/dashboard/offres",
    name: "offres",
    meta: { title: "Offres", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/offres/index")
  },
  {
    path: "/dashboard/services",
    name: "services",
    meta: { title: "Services", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/services/index")
  },
  {
    path: "/dashboard/analytic",
    name: "analytic",
    meta: { title: "Analytic", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/analytic/index")
  },
  {
    path: "/dashboard/termes",
    name: "termes",
    meta: { title: "Termes", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/termes/index")
  },
  {
    path: "/dashboard/enrolements",
    name: "enrolements",
    meta: { title: "Enrolements", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/enrolements/index")
  },
  {
    path: "/dashboard/notifications",
    name: "notifications",
    meta: { title: "Notifications", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/notifications/index")
  },
  {
    path: "/dashboard/assistances",
    name: "assistances",
    meta: { title: "Assistances", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/assistances/index")
  },
  {
    path: "/dashboard/settings",
    name: "settings",
    meta: { title: "Settings", authRequired: true, roles: ["ADMIN"] },
    component: () => import("../views/dashboards/settings/index")
  },

  // --- MODULES APPS (ADMIN, INDIVIDU, PARTENAIRE) ---
  {
    path: "/chat",
    name: "chat",
    meta: { title: "Chat", authRequired: true, roles: [ "INDIVIDUEL"] },
    component: () => import("../views/chat/index")
  },
  {
    path: "/apps/file-manager",
    name: "file-manager",
    meta: { title: "File Manager", authRequired: true, roles: [ "INDIVIDUEL"] },
    component: () => import("../views/file-manager/index")
  },

  // --- E-COMMERCE (INDIVIDU & PARTENAIRE) ---
  // {
  //   path: "/ecommerce/products",
  //   name: "Products",
  //   meta: { title: "Products", authRequired: true, roles: ["INDIVIDUEL"] },
  //   component: () => import("../views/ecommerce/products")
  // },
  // {
  //   path: "/ecommerce/product-detail/:id",
  //   name: "Product Detail",
  //   meta: { title: "Product Detail", authRequired: true, roles: ["INDIVIDUEL", ] },
  //   component: () => import("../views/ecommerce/product-detail")
  // },
  // {
  //   path: "/ecommerce/orders",
  //   name: "Orders",
  //   meta: { title: "Orders", authRequired: true, roles: ["RESPONSABLE_PARTENAIRE", ] },
  //   component: () => import("../views/ecommerce/orders")
  // },

  // // --- JOBS (INDIVIDU) ---
  {
    path: "/jobs/job-list",
    name: "job-list",
    meta: { title: "Job List", authRequired: true, roles: ["RESPONSABLE_PARTENAIRE"] },
    component: () => import("../views/jobs/job-list")
  },


  // --- CRYPTO (PARTENAIRE) ---
  {
    path: "/crypto/wallet",
    name: "Wallet",
    meta: { title: "Wallet", authRequired: true, roles: ["RESPONSABLE_PARTENAIRE"] },
    component: () => import("../views/crypto/wallet/index")
  },
   {
    path: "/crypto/employers",
    name: "employers-crypto",
    meta: { title: "employers", authRequired: true, roles: ["RESPONSABLE_PARTENAIRE"] },
    component: () => import("../views/crypto/employers/user")
  },
   {
    path: "/crypto/offres",
    name: "offres crypto",
    meta: { title: "offres", authRequired: true, roles: ["RESPONSABLE_PARTENAIRE"] },
    component: () => import("../views/crypto/offres/index")
  },
  {
    path: "/crypto/transaction",
    name: "transaction crypto",
    meta: { title: "offres", authRequired: true, roles: ["RESPONSABLE_PARTENAIRE"] },
    component: () => import("../views/crypto/transaction/index")
  },
  {
    path: "/crypto/statistiques",
    name: "statistiques crypto",
    meta: { title: "statistiques", authRequired: true, roles: ["RESPONSABLE_PARTENAIRE"] },
    component: () => import("../views/crypto/statistiques/index")
  },
// employer
{
    path: "/EMPLOYE",
    name: "employers",
    meta: { title: "employers", authRequired: true, roles: ["EMPLOYER"] },
    component: () => import("../views/EMPLOYE/index")
  },
  {
    path: "/EMPLOYE/Beneficiaires",
    name: "Beneficiaires",
    meta: { title: "employers", authRequired: true, roles: ["EMPLOYER"] },
    component: () => import("../views/EMPLOYE/Beneficiaires/ayantDroit")
  },
  {
    path: "/EMPLOYE/cartes",
    name: "cartes",
    meta: { title: "employers", authRequired: true, roles: ["EMPLOYER"] },
    component: () => import("../views/EMPLOYE/cartes/carte")
  },


  {
    path: "/Hopital/Accueil",
    name: "hopital-dashboard", // Donne un nom unique
    meta: { 
      title: "Accueil Hôpital", 
      authRequired: true, 
      roles: ["RESPONSABLE_PARTENAIRE"],
      typePartenaire: "HOPITAL" // Utilise ":" pour définir la clé
    },
    component: () => import("../views/Hopital/Accueil/index")
  },
  // Dans votre fichier de configuration router
{
  path: '/Hopital/paiement',
  name: 'paiement-hopital', // <--- Vérifiez que l'orthographe est identique
  component: () => import('../views/Hopital/paiement/facturation.vue')
},
{
  path: '/Hopital/patient',
  name: 'patient-hopital', // <--- Vérifiez que l'orthographe est identique
  component: () => import('../views/Hopital/patient/consultation.vue')
},
///////////////////////////////////////

// ayant_droit

{
    path: "/ayantDroit/Accueil",
    name: "ayantDroit",
    meta: { title: "beneficiaire", authRequired: true, roles: ["AYANT_DROIT"] },
    component: () => import("../views/ayantDroit/Accueil/benef.vue")
  },
  {
    path: "/ayantDroit/carte",
    name: "carte",
    meta: { title: "carte", authRequired: true, roles: ["AYANT_DROIT"] },
    component: () => import("../views/ayantDroit/carte/carte.vue")
  },


  ////////////////////////////////////////////////////
  // PHARMACIE
  {
    path: "/Pharmacie/Accueil",
    name: "pharmacie-dashboard", // Donne un nom unique
    meta: { 
      title: "Accueil pharmacie", 
      authRequired: true, 
      roles: ["RESPONSABLE_PARTENAIRE"],
      typePartenaire: "PHARMACIE" // Utilise ":" pour définir la clé
    },
    component: () => import("../views/Pharmacie/Accueil")
  },
  {
    path: "/Pharmacie/facturation",
    name: "pharmacie-facturation", // Donne un nom unique
    meta: { 
      title: "facturation pharmacie", 
      authRequired: true, 
      roles: ["RESPONSABLE_PARTENAIRE"],
      typePartenaire: "PHARMACIE" // Utilise ":" pour définir la clé
    },
    component: () => import("../views/Pharmacie/facturation")
  },

{
    path: "/Pharmacie/patient",
    name: "pharmacie-patient", // Donne un nom unique
    meta: { 
      title: "facturation patient", 
      authRequired: true, 
      roles: ["RESPONSABLE_PARTENAIRE"],
      typePartenaire: "PHARMACIE" // Utilise ":" pour définir la clé
    },
    component: () => import("../views/Pharmacie/patient")
  },





  // --- UTILITAIRES & ERREURS ---
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/account/logout"),
    meta: { authRequired: true }
  },
  {
    path: "/404",
    name: "404",
    meta: { title: "404 Error Page" },
    component: require("../views/utility/404").default
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404"
  }
];